export const host = window.location.hostname !== "localhost" ? "wss://lottoworld.games:8443" : "ws://localhost:8880";
